<template>
    <div>
        <Header @show-contact="showContact" :active="1" :title="'荟镜AR1'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/product/product_banner.jpg"></img>
            <img class="banner_m" src="../../assets/image/product/ar_banner_m.png"></img>
        </div>
        <div class="detail-vr">
            <img src="../../assets/image/product/ar_detail.png"></img>
            <h1>荟镜AR1头显产品介绍</h1>
        </div>
        <div class="advantage-ar">
            <h1>产品优势</h1>
            <div class="first">
                <div class="dof">
                    <p>轻量化设计</p>
                    <p>重量轻体积小，适合长时间佩戴</p>
                    <img src="../../assets/image/product/ar_light.png">
                </div>
                <div class="dof">
                    <p>大视场角</p>
                    <p>更宽广的视野，视觉感知更为自然</p>
                    <img src="../../assets/image/product/xr_fov.jpg">
                </div>
                <div class="dof">
                    <p>双6DOF</p>
                    <p>扩大运动识别范围 更加灵活自由</p>
                    <img src="../../assets/image/product/xr_6dof.jpg">
                </div>
            </div>
            <div class="second">
                <div class="txt">
                    <p>3D空间定位立体声效</p>
                    <p>身临其境，提供沉浸式听觉体验</p>
                    <img src="../../assets/image/product/ar_sound.png">
                </div>
                <div class="txt">
                    <p>全自由度手势操作</p>
                    <p>眼镜捕捉手部，实现全自由度的自然手势追踪</p>
                    <img src="../../assets/image/product/ar_action.png">
                </div>
                <div class="txt">
                    <p>世界级空间定位技术</p>
                    <p>SLAM算法，厘米级定位，室内外稳定交互</p>
                    <img src="../../assets/image/product/ar_position.jpg">
                </div>
                <div class="txt">
                    <p>高性能硬件配置</p>
                    <p>搭载高通骁龙845平台，玩转各种游戏</p>
                    <img src="../../assets/image/product/ar_configuration.png">
                </div>
            </div>
            <h2>产品配置</h2>
            <div class="third">
                <div class="product-item">
                    <p>产品形态</p>
                </div>
                <div class="product-item">
                    <p>一体机</p>
                </div>
                <div class="product-item">
                    <p>重量</p>
                </div>
                <div class="product-item">
                    <p>120g</p>
                </div>
            </div>
             <div class="third" style="top:13.43rem">
                <div class="product-item">
                    <p>尺寸</p>
                </div>
                <div class="product-item">
                    <p>219.2*171.2*67.8mm</p>
                </div>
                <div class="product-item">
                    <p>视场角</p>
                </div>
                <div class="product-item">
                    <p>55°</p>
                </div>
            </div>
            <div class="third" style="top:13.83rem">
                <div class="product-item">
                    <p>光学方案</p>
                </div>
                <div class="product-item">
                    <p>Birdbath</p>
                </div>
                <div class="product-item">
                    <p>单眼分辨率</p>
                </div>
                <div class="product-item">
                    <p>1920*1080</p>
                </div>
            </div>
            <div class="third" style="top:14.23rem">
                <div class="product-item">
                    <p>芯片</p>
                </div>
                <div class="product-item">
                    <p>高通骁龙845平台</p>
                </div>
                <div class="product-item">
                    <p>摄像头</p>
                </div>
                <div class="product-item">
                    <p>1300万主摄+双6D0F空间定位摄像头</p>
                </div>
            </div>
            <div class="third" style="top:14.63rem">
                <div class="product-item">
                    <p>时延</p>
                </div>
                <div class="product-item">
                    <p>≤16ms</p>
                </div>
                <div class="product-item">
                    <p>陀螺仪</p>
                </div>
                <div class="product-item">
                    <p>博世九轴IMU，刷新率高达1000HZ</p>
                </div>
            </div>
            <div class="third" style="top:15.03rem">
                <div class="product-item">
                    <p>交互</p>
                </div>
                <div class="product-item">
                    <p>全自由度手势操作</p>
                </div>
                <div class="product-item">
                    <p>电池</p>
                </div>
                <div class="product-item">
                    <p>内置1000mAh高密度电池</p>
                </div>
            </div>
            <div class="third" style="top:15.43rem">
                <div class="product-item">
                    <p></p>
                </div>
                <div class="product-item">
                    <p>智能手柄</p>
                </div>
                <div class="product-item">
                    <p></p>
                </div>
                <div class="product-item">
                    <p>外置2000mAh高密度电池*2</p>
                </div>
            </div>
            <div class="third" style="top:15.83rem">
                <div class="product-item">
                    <p>传输功能</p>
                </div>
                <div class="product-item">
                    <p>Wi-Fi, Bluetooth, UsB 3.1,Type-C接囗</p>
                </div>
                <div class="product-item">
                    <p>操作系统</p>
                </div>
                <div class="product-item">
                    <p>Blue Cat 2.0</p>
                </div>
            </div>
        </div>
        <div class="advantage_m">
            <img src="../../assets/image/product/ar_m_1.png">
            <img src="../../assets/image/product/ar_m_2.jpg">
            <img src="../../assets/image/product/ar_m_3.png">
            <img src="../../assets/image/product/ar_m_4.png">
            <img src="../../assets/image/product/ar_else.png">
        </div>
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
} 
</script>
<style scoped>
@import '../../assets/css/product/ar.css';
</style>